import { useState, useRef } from 'react'
import { TransformWrapper, TransformComponent } from 'react-zoom-pan-pinch'
import type { ReactZoomPanPinchRef } from 'react-zoom-pan-pinch'
import { ImageNotFound } from '../../assets'
import { useWindowSize } from '../../hooks'
import { Box } from '../Layout'
import { Dialog } from './Dialog'
import { Spinner } from '../Loading'

interface ZoomDialogProps {
  open: boolean
  onClose: () => void
  image?: string
  alt?: string
}

export function ZoomDialog({ open, onClose, image = ImageNotFound, alt = 'Zoomed Image' }: ZoomDialogProps) {
  const { height, width } = useWindowSize()
  const [loading, setLoading] = useState(true)
  const transformRef = useRef<ReactZoomPanPinchRef>(null)

  const imageLoaded = () => {
    setLoading(false)
  }

  const handleWheel = (e: React.WheelEvent<HTMLDivElement>) => {
    if (!transformRef.current) return
    e.preventDefault()
    const { state, setTransform, zoomIn, zoomOut, instance } = transformRef.current
    if (e.ctrlKey) {
      if (e.deltaY < 0) {
        zoomIn()
      } else {
        zoomOut()
      }
    } else {
      const wrapperH = instance.wrapperComponent?.clientHeight ?? height
      const contentH = (instance.contentComponent?.clientHeight ?? 0) * state.scale
      const minY = Math.min(0, wrapperH - contentH)
      const newY = Math.max(minY, Math.min(0, state.positionY - e.deltaY))
      setTransform(state.positionX, newY, state.scale, 0)
    }
  }

  return (
    <Dialog
      fullWidth
      open={open}
      onClose={onClose}
      slotProps={{
        paper: {
          sx: {
            width: { mobile: '100%', laptop: '95%' },
            maxHeight: { mobile: '100%', laptop: '95%' },
            maxWidth: { laptop: '95%' },
            overflow: 'hidden',
            margin: 0,
          },
        },
      }}
    >
      <Box onWheel={handleWheel} height={height} width={width} overflow='hidden' sx={{ marginTop: 2 }}>
        <Box display={loading ? 'block' : 'none'} pt={32} textAlign='center'>
          <Spinner size={120} />
        </Box>
        <TransformWrapper ref={transformRef} wheel={{ disabled: true }}>
          <TransformComponent
            wrapperStyle={{ width: '100%', height: '100%', display: loading ? 'none' : 'flex' }}
            contentStyle={{ width: '100%', justifyContent: 'center', alignItems: 'center' }}
          >
            <img
              src={image}
              alt={alt}
              width={2000}
              onLoad={imageLoaded}
              style={{
                maxWidth: '90%',
                maxHeight: '90%',
                objectFit: 'contain',
                borderRadius: 8,
              }}
            />
          </TransformComponent>
        </TransformWrapper>
      </Box>
    </Dialog>
  )
}
